import type { User } from 'firebase/auth';
import { Check, Lock, Mail, User as UserIcon } from '../../components/ui/icons';
import { ActionRow, Divider, Group, Row, SectionLabel } from './SettingsRows';

export function AccountSection({
  user,
  username,
  isPasswordUser,
  resetState,
  onResetPassword
}: {
  user: User | null | undefined;
  username: string;
  isPasswordUser: boolean;
  resetState: 'idle' | 'sending' | 'sent';
  onResetPassword: () => void;
}) {
  return (
    <>
      <SectionLabel>Account</SectionLabel>
      <Group>
        <Row icon={<Mail width={17} height={17} strokeWidth={2} className="text-white" />} iconBg="#3B7DE0" label="Email">
          <span className="truncate text-[14px] font-medium text-ink2">{user?.email ?? '—'}</span>
        </Row>
        <Divider />
        <Row icon={<UserIcon width={17} height={17} strokeWidth={2} className="text-white" />} iconBg="#15151B" label="Username">
          <span className="text-[14px] font-medium text-ink2">{username || '—'}</span>
        </Row>
        {isPasswordUser && (
          <>
            <Divider />
            <ActionRow
              icon={<Lock width={16} height={16} strokeWidth={2} className="text-white" />}
              iconBg="#6E6E73"
              label={resetState === 'sent' ? 'Reset link sent' : 'Password & security'}
              onClick={onResetPassword}
              trailing={
                resetState === 'sent' ? (
                  <Check width={18} height={18} strokeWidth={3} className="text-accent-ink" />
                ) : undefined
              }
            />
          </>
        )}
      </Group>
    </>
  );
}
